/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiModulesListParams = zod.strictObject({
    exclude: zod.string().optional(),
    format: zod.enum(['csv', 'json']).optional(),
    order: zod.string().optional(),
    search: zod.string().optional(),
});

export type ApiModulesListParams = zod.input<typeof ApiModulesListParams>;
export type ApiModulesListParamsOutput = zod.output<
    typeof ApiModulesListParams
>;
